<script setup lang="ts">
import UIKit, { type ITableColumn } from '@pocketprep/ui-kit'
import { type TSubjectRow } from '@/components/Stats/GroupStats/GroupSubjectTable.vue'

const { Icon } = UIKit

const props = defineProps<{
    row: TSubjectRow
    column: ITableColumn
}>()
</script>

<template>
    <div
        class="group-subject-row"
    >
        <template v-if="props.column.propName === 'subject'">
            <div
                v-if="props.column.propName === 'subject'"
                class="group-subject-row__subject"
            >
                {{ props.row.subject }}
            </div>
        </template>
        <template v-else-if="props.column.propName === 'numStudentFlagged'">
            <div class="group-subject-row__flagged">
                <div class="group-subject-row__numOfStudents">
                    {{ props.row.numFlaggedSubject }}
                </div>
                <Icon
                    class="group-subject-row__flag-icon"
                    type="flag"
                />
            </div>
        </template>
    </div>
</template>

<style lang="scss" scoped>


.group-subject-row {
    &__subject {
        margin-bottom: 6px;
        color: $brand-black;
        font-size: 15px;
        line-height: 22px;
        width: 645px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
    }

    &__flagged {
        display: flex;
        height: 5px;
        padding-right: 16px;
    }

    &__numOfStudents {
        align-items: center;
        color: $brand-black;
        font-weight: 600;
        font-size: 15px;
        line-height: 18px;
        margin-top: 2px;
    }

    &__flag-icon {
        height: 22px;
        width: 22px;
    }

    &__flag-icon,
    &__icon {
        color: $slate;
    }
}
</style>
